import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './About.css';

const About = () => {
  const { tr } = useLanguage();

  return (
    <section id="sobre" className="about">
      <div className="about-inner">
        <img className="about-photo" src="assets/me.png" alt="João Pedro Carvalho" />
        <div className="about-body">
          <p className="section-title">{tr.about.title}</p>
          <div className="about-paragraphs">
            {tr.about.paragraphs.map((text, i) => (
              <p key={i}>{text}</p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
